import React from 'react';
import {connect} from "react-redux";
import {contains, isEqual} from "underscore";

import ModuleList from './ModuleList';
import AreaControlList from './AreaControlList'

import {
    updateModuleItemQuery,
    updateAreaControlledItemQuery,
    getUnassignedModuleItems,
    placeModuleItemsUnderAreaControl,
    removeFromAreaControl,
    getAreaControlledItems
} from './reducer';

import SearchField from "../../components/SearchField";

export class AssignmentPanel extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedModuleItemGtins: {},
            selectedAreaControlledItems: {}
        };

        this.toggleAllModuleItems = this.toggleAllModuleItems.bind(this);
        this.clearSelectedModuleItems = this.clearSelectedModuleItems.bind(this);
        this.toggleModuleItemSelection = this.toggleModuleItemSelection.bind(this);

        this.toggleAllAreaControlledItems = this.toggleAllAreaControlledItems.bind(this);
        this.clearSelectedAreaControlledItems = this.clearSelectedAreaControlledItems.bind(this);
        this.toggleAreaControlledItemSelection = this.toggleAreaControlledItemSelection.bind(this);

        this.addItemsToAreaControl = this.addItemsToAreaControl.bind(this);
        this.removeItemsFromAreaControl = this.removeItemsFromAreaControl.bind(this);
    }

    toggleAllModuleItems() {
        if(Object.keys(this.state.selectedModuleItemGtins).length > 0) {
            this.clearSelectedModuleItems();
        } else {
            let selectedModuleItemGtins = this.props.moduleItems.reduce((map, item) => {
                map[item.article.gtin] = item.article.gtin;
                return map;
            }, {});
            this.setState({
                selectedModuleItemGtins: selectedModuleItemGtins
            });
        }
    }

    toggleModuleItemSelection(gtin) {
        let selectedModuleItemGtins = this.state.selectedModuleItemGtins;
        if(contains(selectedModuleItemGtins, gtin)) {
            delete selectedModuleItemGtins[gtin];
        } else {
            selectedModuleItemGtins[gtin] = gtin;
        }
        this.setState({
            selectedModuleItemGtins: selectedModuleItemGtins
        });
    }

    clearSelectedModuleItems() {
        this.setState({
            selectedModuleItemGtins: {}
        });
    }

    toggleAllAreaControlledItems() {
        if(Object.keys(this.state.selectedAreaControlledItems).length > 0) {
            this.clearSelectedAreaControlledItems();
        } else {
            let selectedAreaControlledItems = this.props.areaControlledItems.reduce((map, item) => {
                map[item.id] = item.id;
                return map;
            }, {});
            this.setState({
                selectedAreaControlledItems: selectedAreaControlledItems
            });
        }
    }

    toggleAreaControlledItemSelection(id) {
        let selectedAreaControlledItems = this.state.selectedAreaControlledItems;
        if(contains(selectedAreaControlledItems, id)) {
            delete selectedAreaControlledItems[id];
        } else {
            selectedAreaControlledItems[id] = id;
        }
        this.setState({
            selectedAreaControlledItems: selectedAreaControlledItems
        });
    }

    clearSelectedAreaControlledItems() {
        this.setState({
            selectedAreaControlledItems: {}
        });
    }

    addItemsToAreaControl() {
        const gtins = Object.keys(this.state.selectedModuleItemGtins);

        if(gtins.length > 0) {
            this.props.placeModuleItemsUnderAreaControl(gtins);
        }

        this.clearSelectedModuleItems();
        this.clearSelectedAreaControlledItems();
    }

    removeItemsFromAreaControl() {
        const ids = Object.keys(this.state.selectedAreaControlledItems);
        if(ids.length > 0) {
            this.props.removeFromAreaControl(ids);
        }
        this.clearSelectedModuleItems();
        this.clearSelectedAreaControlledItems();
    }

    componentDidUpdate(prevProps) {
        if(!isEqual(this.props.moduleItems, prevProps.moduleItems)) {
            this.clearSelectedModuleItems();
            this.clearSelectedAreaControlledItems();
        }
        if(!isEqual(this.props.areaControlledItems, prevProps.areaControlledItems)) {
            this.clearSelectedModuleItems();
            this.clearSelectedAreaControlledItems();
        }
    }

    render() {

        const totalItemCount = this.props.moduleItems.length + this.props.areaControlledItems.length;

        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-5">
                            <h6>Nicht zugeordnete Artikel ({this.props.moduleItems.length}/{totalItemCount})</h6>
                            <hr/>
                        </div>
                        <div className="col-lg-2">
                        </div>
                        <div className="col-lg-5">
                            <h6>Dem Store zugeordnete Artikel ({this.props.areaControlledItems.length}/{totalItemCount})</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={this.props.moduleItemQuery}
                                         onCommit={this.props.updateModuleItemQuery}/>
                        </div>
                        <div className="col-lg-2">
                        </div>
                        <div className="col-lg-5">
                            <SearchField className="mb-2 mr-sm-2 mb-sm-0"
                                         value={this.props.areaControlledItemQuery}
                                         onCommit={this.props.updateAreaControlledItemQuery}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            <ModuleList moduleItems={this.props.moduleItems}
                                        selectedGtins={this.state.selectedModuleItemGtins}
                                        toggleItemSelection={this.toggleModuleItemSelection}
                                        toggleAllItems={this.toggleAllModuleItems}/>
                        </div>
                        <div className="col-lg-2">
                            <div className="row mt-auto">
                                <div className="col-4">
                                </div>
                                <div className="col-4">
                                    <button className="btn btn-default mt-3" style={{width: '100%', margin: '10px 0px'}}
                                            type="button" onClick={this.addItemsToAreaControl}>
                                        <i className="fa fa-angle-right">&nbsp;</i>
                                    </button>

                                    <button className="btn btn-default mt-5" style={{width: '100%', margin: '10px 0px'}}
                                            type="button" onClick={this.removeItemsFromAreaControl}>
                                        <i className="fa fa-angle-left">&nbsp;</i>
                                    </button>
                                </div>
                                <div className="col-4">
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <AreaControlList areaControlledItems={this.props.areaControlledItems}
                                             selectedItems={this.state.selectedAreaControlledItems}
                                             toggleItemSelection={this.toggleAreaControlledItemSelection}
                                             toggleAllItems={this.toggleAllAreaControlledItems}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        areaControlledItemQuery: state.areacontrolAdmin.get('areaControlledItemQuery'),
        selectedModule: state.areacontrolAdmin.get('selectedModule'),
        moduleItemQuery: state.areacontrolAdmin.get('moduleItemQuery'),
        moduleItems: getUnassignedModuleItems(state.areacontrolAdmin).toJS(),
        areaControlledItems: getAreaControlledItems(state.areacontrolAdmin).toJS()
    };
}

const actions = {
    updateModuleItemQuery,
    updateAreaControlledItemQuery,
    getUnassignedModuleItems,
    placeModuleItemsUnderAreaControl,
    removeFromAreaControl
};

const ConnectedAssignmentPanel = connect(mapStateToProps, actions)(AssignmentPanel);

export default ConnectedAssignmentPanel;


// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/AssignmentPanel.js